const buttonConfigs = [
    {
      buttonClass: "wizzy-three-products-per-row",
      bodyClass: "wizzy-three-products-per-row",
      tileViewLevel: "2"
    }, 
    {
      buttonClass: "wizzy-single-products-per-row",
      bodyClass: "wizzy-single-products-per-row",
      tileViewLevel: "1"
    }
];

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("wizzy init", data);
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {
          desktop: 3000,
          mobile: 2000
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {

      var collectionHeader = document.querySelector("collection-header#CollectionHeaderSection");

      if (collectionHeader) {
        collectionHeader.style.display = 'none';
      }

      var collectionTitle = document.querySelector(".section-header__title");

      if (collectionTitle) {
          const pageWidthParent = collectionTitle.closest(".page-width");
          if (pageWidthParent) {
            pageWidthParent.style.display = 'none';
          }
      }

      data.attributeFacetValuesLimit = 100;

      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      data.filters.attributeFacetValuesLimit = 100;
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER,
    function (data) {
      
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // console.log("Wiz BEFORE_RENDER_RESULTS", data);
      if (data.api === "search" || data.api === "filter") {
          var facets = data?.response?.payload?.facets;
          facets?.forEach((facet) => {
            // if (facet.key === "sizes") {
            //   let sizes = facet.data;
    
            //   let newArray = new Array();
            //   let temp = [
            //     "XXS",
            //     "XS",
            //     "S",
            //     "S/M",
            //     "M",
            //     "L",
            //     "L/XL",
            //     "XL",
            //     "XXL",
            //     "XXXL",
            //     "0/3",
            //     "3/6",
            //     "6/12",
            //     "12/18",
            //     "18/24",
            //     "2",
            //     "4",
            //     "6",
            //     "8",
            //     "10",
            //     "12",
            //     "14",
            //     "16",
            //     "26",
            //     "28",
            //     "30",
            //     "32",
            //     "34",
            //     "36",
            //     "38",
            //     "40",
            //     "42",
            //     "44",
            //     "10+ years",
            //     "375 ml",
            //     "620ml",
            //     "620 ml",
            //     "750ml",
            //     "900 ml",
            //     "950ml",
            //     "950 ml",
            //     "975 ml",
            //     "1100ml",
            //     "1X",
            //     "2X",
            //     "3X",
            //     "4X",
            //     "5X",
            //     "6X",
            //     "2-3Y",
            //     "3-4Y",
            //     "4.5Y",
            //     "5Y",
            //     "5-6Y",
            //     "5.5Y",
            //     "11-13Y",
            //     "6 - 7 years",
            //     "6.5 - 7 years",
            //     "7 - 8 years",
            //     "8 - 9 years",
            //     "9 - 10 years",
            //     "10 years",
            //     "EXT",
            //     "L/G",
            //     "One Size",
            //     "OS",
            //     "Regular",
            //     "UK-3",
            //     "UK-3.5",
            //     "UK-4",
            //     "UK-4.5",
            //     "UK-5",
            //     "UK-5.5",
            //     "UK-6",
            //     "UK-6.5",
            //     "UK-7",
            //     "UK-7.5",
            //     "UK-8",
            //     "UK-8.5",
            //     "UK-9",
            //     "UK-9.5",
            //     "UK-10",
            //     "UK-10.5",
            //     "UK-11",
            //     "UK-12",
            //     "UK-13",
            //     "UK-14",
            //     "W 9-11"
            //   ];
            //   for (let j = 0; j < temp.length; j++) {
            //     for (let k = 0; k < sizes.length; k++) {
            //       if (sizes[k].key == temp[j]) newArray.push(sizes[k]);
            //     }
            //   }
    
            //   facet.data = newArray;
            // }
            // else if (Array.isArray(facet.data)) {
            //   facet.data.sort((a, b) => a.label.localeCompare(b.label));
            // }

            if (facet.key === "product_value_tags_color_tags") {
              const facetItem = facet.data;
              facetItem?.forEach((item) => {
                const colorVal =
                  item.key === "Multicolor"
                    ? "linear-gradient(to right, red 33%, yellow 33%, yellow 66%, blue 66%)"
                    : item.key;
                item.isSwatch = true;
                item.isURLSwatch = false;
                item.isVisualSwatch = true;
                item.swatchValue = colorVal;
                item.data = {
                    value: item.key,
                    swatch: {
                        type: 'visual',
                        value: colorVal
                    }
                }

              });
            }
          });
      }
      
      return data;
    }
  );
  function initFacetNoResultsMessage() {
    if (window.__facetNoResultsObserverInitialized) return;
    window.__facetNoResultsObserverInitialized = true;

    const NO_RESULT_CLASS = "wizzy-no-facet-results";
    const MESSAGE_TEXT = "No matching results found";

    function update(facetBody) {
      const ul = facetBody.querySelector(".wizzy-facet-list");
      if (!ul) return;

      const items = ul.querySelectorAll("li");

      const hasVisibleItem = Array.from(items).some(
        li => li.offsetParent !== null
      );

      let msg = facetBody.querySelector(`.${NO_RESULT_CLASS}`);

      if (!hasVisibleItem) {
        if (!msg) {
          msg = document.createElement("div");
          msg.className = NO_RESULT_CLASS;
          msg.textContent = MESSAGE_TEXT;
          ul.appendChild(msg);
        }
      } else if (msg) {
        msg.remove();
      }
    }

    function scan() {
      document
        .querySelectorAll(".facet-search-wrapper")
        .forEach(searchWrapper => {
          const facetBody = searchWrapper.closest(".wizzy-facet-body");
          facetBody && update(facetBody);
        });
    }

    const observer = new MutationObserver(scan);

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_FILTER_ITEM_CLICKED,
    function (data) {
      window.scrollTo(0, 0);
      let apply_button = document.querySelector('.wizzy-apply-all-button');
      if(apply_button)
      {
        apply_button.addEventListener('click', function(){
          
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 500);
        });
      }
      return data;
    });

    function initMobileNavObserver() {
    const target = document.querySelector(
      '.site-header__drawer.site-header__mobile-nav'
    );

    if (!target) return;

    const selector = `.wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container .wizzy-common-select-wrapper .wizzy-common-select-container .wizzy-common-select-selector`;

    const observer = new MutationObserver(() => {
      const sortSelectorEl = document.querySelector(selector);

      if (!sortSelectorEl) return;

      if (target.classList.contains('is-active')) {
        sortSelectorEl.style.setProperty('display', 'none', 'important');
      } else {
        sortSelectorEl.style.removeProperty('display');
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  }




  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      initMobileNavObserver();
      // console.log("Wiz VIEW_RENDERED", data);
      initFacetNoResultsMessage();
      if (window.collectionName) {
        var collectionTitle = document.querySelector("h1.collection-hero__title");
        if (collectionTitle) {
          collectionTitle.innerHTML = `<span class="visually-hidden">Collection: </span>${window.collectionName}`;
        }
      }

      var productsCount = window.wizzyConfig?.pageStore?.searchedResponse?.total;
      if (productsCount) {
        var productCountElement = document.querySelector('#ProductCountDesktop');
        if (productCountElement) {
          productCountElement.innerHTML = `<span id="wz-ProductCountDesktop">${productsCount} Products<span>`
        }
      }

        buttonConfigs.forEach(function (config) {
            var button = null;

            if (window.innerWidth > 768) {
                button = document.querySelector(
                    "button.tile-view-btn." + config.buttonClass
                );
            } else {
                button = document.querySelector(
                    "button.tile-view-btn." + config.buttonClass
                );
            }

            var searchWrapper = document.querySelector(".wizzy-search-wrapper");

            if (button && searchWrapper) {
                button.addEventListener("click", function () {
                    // Remove existing layout classes
                    document.body.classList.remove(
                        "wizzy-three-products-per-row",
                        "wizzy-single-products-per-row"
                    );

                    // Add selected layout class
                    document.body.classList.add(config.bodyClass);

                    // Set tile view level
                    searchWrapper.setAttribute(
                        "wizzy-tile-view-level",
                        config.tileViewLevel
                    );

                    // Reset active state
                    document.querySelectorAll("button.tile-view-btn").forEach(function (btn) {
                        btn.classList.remove("is-active");
                    });

                    // Mark current button active
                    button.classList.add("is-active");

                    try {
                      var wizzyStore = JSON.parse(localStorage.getItem("wizzy_store")) || {};

                      wizzyStore.PRODUCTS_PER_ROW = config.tileViewLevel * 2;

                      localStorage.setItem("wizzy_store", JSON.stringify(wizzyStore));
                    } catch (e) {
                        console.error("Failed to update wizzy_store in localStorage", e);
                    }
                });
            }
        });


      initProductMetafieldSwatches();
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      document.body.classList.add('wizzy-search-results-rendered');

      if (window.collectionName) {
        var collectionTitle = document.querySelector("h1.collection-hero__title");
        if (collectionTitle) {
          collectionTitle.innerHTML = `<span class="visually-hidden">Collection: </span>${window.collectionName}`;
        }
      }

      var productsCount = window.wizzyConfig?.pageStore?.searchedResponse?.total;
      if (productsCount) {
        var productCountElement = document.querySelector('#ProductCountDesktop');
        if (productCountElement) {
          productCountElement.innerHTML = `<span id="ProductCountDesktop">${productsCount} items<span>`
        }
      }

        buttonConfigs.forEach(function (config) {
            var button = null;

            if (window.innerWidth > 768) {
                button = document.querySelector(
                    "button.tile-view-btn." + config.buttonClass
                );
            } else {
                button = document.querySelector(
                    "button.tile-view-btn." + config.buttonClass
                );
            }

            var searchWrapper = document.querySelector(".wizzy-search-wrapper");

            if (button && searchWrapper) {
                button.addEventListener("click", function () {
                    // Remove existing layout classes
                    document.body.classList.remove(
                        "wizzy-three-products-per-row",
                        "wizzy-single-products-per-row"
                    );

                    // Add selected layout class
                    document.body.classList.add(config.bodyClass);

                    // Set tile view level
                    searchWrapper.setAttribute(
                        "wizzy-tile-view-level",
                        config.tileViewLevel
                    );

                    // Reset active state
                    document.querySelectorAll("button.tile-view-btn").forEach(function (btn) {
                        btn.classList.remove("is-active");
                    });

                    // Mark current button active
                    button.classList.add("is-active");

                    try {
                      var wizzyStore = JSON.parse(localStorage.getItem("wizzy_store")) || {};

                      wizzyStore.PRODUCTS_PER_ROW = config.tileViewLevel * 2;

                      localStorage.setItem("wizzy_store", JSON.stringify(wizzyStore));
                    } catch (e) {
                        console.error("Failed to update wizzy_store in localStorage", e);
                    }
                });
            }
        });

      initProductMetafieldSwatches();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED", data);
      data.forEach((product) => {
        // console.log("Wizzy product id", product.id);
        // console.log("Wizzy product singleVarientGroupId", product.singleVarientGroupId);
        if (typeof product.attributes === "undefined") {
          product.attributes = [];
        }
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_technologies_images_custom") {
            product.techImage = attribute.values[0].value[0].split("||")[0];
          }

          if (attribute.id === "product_tags" && attribute.values?.[0]?.value?.[0]) {
            const tags = attribute.values[0].value[0]
              .split(",")
              .map(tag => tag.trim().toLowerCase());

            if (tags.includes("bestseller")) {
              product.displayTag = "Best Seller";
            }
          }

          if (attribute.id === "product_product_mapping_custom") {
            var swatchValue = attribute.values[0].value[0];
            if (isJsonString(swatchValue)) {
              var productSwatchList = JSON.parse(swatchValue);
              let currentProductId = (product.groupId || product.id)?.toString();

              const hasValidSwatchGroupId = Array.isArray(productSwatchList) &&
                productSwatchList.every(
                  swatch => swatch?.swatchGroupId !== undefined && swatch?.swatchGroupId !== null
                );

              // console.log("wizzy id", currentProductId);
              if (hasValidSwatchGroupId) {
                let matchedIndex = productSwatchList.findIndex(
                  (swatch) => swatch.swatchGroupId?.toString() === currentProductId
                );

                // console.log("wizzy matchedIndex", matchedIndex);
                if (matchedIndex > -1) {
                  let matchedSwatch = productSwatchList.splice(matchedIndex, 1)[0];
                  matchedSwatch.isSwatchSelected = true;
                  productSwatchList.unshift(matchedSwatch);
                }
                // console.log("Wizzy swatchList", productSwatchList);
                product.fullSwatchList = productSwatchList;

                const isMobile = window.innerWidth <= 768;
                const swatchLimit = isMobile ? 3 : 4;
            
                product.swatchList = productSwatchList.slice(0, swatchLimit);
                if (Array.isArray(productSwatchList)) {
                  product.remainingProductSwatchCount = productSwatchList.length > swatchLimit ? productSwatchList.length - swatchLimit: 0;
                }
              }
            }
          }
        });

        if (product.groupId === "") {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_variant_ids") {
              product.ATCId = attribute.values[0].value[0];
            }
          });
        }

        if (product.swatches && product.swatches.length > 0) {
          product.swatches.forEach((swatch) => {
            if (swatch.key === "colors") {
              var values = swatch.values;

              var isMobile = window.innerWidth < 768;
              var visibleCount = isMobile ? 3 : 4;
              
              product.remainingSwatchCount = values.length > visibleCount ? values.length - visibleCount: 0;
              swatch.values = values.slice(0, visibleCount);

            }
          });
        }

        if (product.categories && product.categories.length > 0) {
          product.categories.forEach((category) => {
            if (
              category.id === "new-arrivals" ||
              category.id === "just-arrived"
            ) {
              product.displayTag = "New Arrivals";
            }
          });
        }
      });

      return data;
    },
    1
  );
};

(function () {
    if (window.innerWidth <= 768) return;

    const searchInput = document.querySelector(".small--hide input#Search.search__input");

    if (!searchInput) return;

    let isScrolling = false;

    function positionAutocomplete() {
        if (isScrolling) return;

        const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
        if (!autocomplete) return;

        const rect = searchInput.getBoundingClientRect();

        autocomplete.style.top = rect.bottom + "px";
        autocomplete.style.left = rect.left + "px";
    }

    window.addEventListener("scroll", function () {
        isScrolling = true;
        clearTimeout(window.__wizzyScrollTimer);
        window.__wizzyScrollTimer = setTimeout(function () {
            isScrolling = false;
        }, 150);
    }, { passive: true });

    searchInput.addEventListener("click", positionAutocomplete);

    const observer = new MutationObserver(function () {
        positionAutocomplete();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

function isJsonString(str) {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed); // Only return true if it's an array
  } catch (e) {
    return false;
  }
}

function generateSrcSet(imageUrl) {
  if (!imageUrl || typeof imageUrl !== "string") {
    return "";
  }
  const widths = [240, 352, 832, 1200, 1600, 1920, 2560, 3840];

  return widths
    .map(width => `${imageUrl}?width=${width} ${width}w`)
    .join(', ');
}

function initProductMetafieldSwatches() {
  var productMetafieldSwatch = document.querySelectorAll('.wizzy-result-product .wizzy-result-product-item .product-item-swatch-group.swatch-group-metafield .product-item-secondary-swatch-item');

  if (productMetafieldSwatch.length > 0) {
    productMetafieldSwatch.forEach((swatch) => {
      if (swatch.classList.contains('wizzy-swatch-bound')) return;

      swatch.classList.add('wizzy-swatch-bound');

      swatch.addEventListener('click', function(){
        const productCard = swatch.closest('.wizzy-result-product');
        if (!productCard) return;

        const title = swatch.dataset.title;
        const link = swatch.dataset.link;
        const image = swatch.dataset.image;
        const hoverImage = swatch.dataset.imageHover;
        const sellingPriceValue = swatch.dataset.price;
        const compareAtPriceValue = swatch.dataset.compareAtPrice;

        const titleAnchor = productCard.querySelector('.product-item-title a');
        if (titleAnchor && title && link) {
          titleAnchor.textContent = title;
          titleAnchor.href = link;
          titleAnchor.title = title;
        }

        const mainImage = productCard.querySelector('.product-item-image:not(.hover-image)');
        const hoverImg = productCard.querySelector('.product-item-image.hover-image');

        if (mainImage && image) {
          mainImage.src = image;
          mainImage.srcset = generateSrcSet(image);
          mainImage.alt = title || '';
        }

        if (hoverImg) {
          hoverImg.src = hoverImage || image || '';
          if(hoverImage)
          {
            hoverImg.srcset = generateSrcSet(hoverImage);
          }
          else
          {
            hoverImg.srcset = generateSrcSet(image);
          }
          hoverImg.alt = title || '';
        }

        const imageWrapper = productCard.querySelector('.result-product-item-image-wrapper');
        if (imageWrapper && link) {
          imageWrapper.href = link;
          imageWrapper.title = title || '';
        }

        const sellingPriceEl = productCard.querySelector('.product-item-selling-price');
        if (sellingPriceEl && sellingPriceValue) {
          sellingPriceEl.textContent = `$${sellingPriceValue}`;
        }

        const discountLabelEl = productCard.querySelector('.result-product-item-label.result-product-item-label-sale');
        if (discountLabelEl) {
          discountLabelEl.style.display = 'none';
        }

        const compareAtPriceEl = productCard.querySelector('.product-item-original-price');
        if (compareAtPriceEl && sellingPriceEl) {
          if (compareAtPriceValue) {
            compareAtPriceEl.textContent = `$${compareAtPriceValue}`;
            compareAtPriceEl.style.display = '';
            sellingPriceEl.classList.add('discount-available');
          } else {
            compareAtPriceEl.style.display = 'none';
            sellingPriceEl.classList.remove('discount-available');
          }
        }

        const atcWrapper = productCard.querySelector('.product-item-variant-ATC');
        if (atcWrapper && link) {
          atcWrapper.href = link;
        }

        const swatchCountLink = productCard.querySelector('.wz-swatch-count');
        if (swatchCountLink && link) {
          swatchCountLink.href = link;
        }

        const swatchGroup = swatch.parentElement;
        swatchGroup.querySelectorAll('.swatch-selected')
          .forEach(el => el.classList.remove('swatch-selected'));

        swatch.classList.add('swatch-selected');
      });
    });
  }
}

